import { Queue } from 'workbox-background-sync';


export function postMessageToAllClients(messages) {
    console.log(`[service-worker] postMessageToAllClients : posting messages ${messages}`)
    self.clients.matchAll().then(clients_ => {
        clients_.forEach(client => {
            client.postMessage(messages);
        });
    });
}


export const setupStoreDeviceMessagesOnNetworkError = () => {
    const deviceMessagesQueue = new Queue('deviceMessages',{
        onSync({ queue }) {
            console.log('[service-worker] : setupStoreDeviceMessagesOnNetworkError : Queue Sync in progress...')
            queue.replayRequests().then(() => {
                console.log('[service-worker] : setupStoreDeviceMessagesOnNetworkError : Requests replayed');
                return queue.getAll();
            }).then(queueEntries => {
                console.log(`[service-worker] : setupStoreDeviceMessagesOnNetworkError : Broadcasting queue count of ${queueEntries.length}`);
                postMessageToAllClients({ type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT', value: queueEntries.length });
            })
            console.log('[service-worker] : Queue Sync done !');
        }
    });

    self.addEventListener('message', event => {
        console.log(`[service-worker] : message : Received message ${event.data?.action}`)

        // Try sending pending requests
        if (event.data && event.data.action === 'FLUSH_QUEUE' && event.data.queueName === 'deviceMessages') {
            console.log(`[service-worker] : message : FLUSH_QUEUE Forced replay of queue`)

            deviceMessagesQueue.replayRequests().then(() => {
                console.log('[service-worker] : message : Requests replayed');
                deviceMessagesQueue.getAll()
                    .then(queueEntries => {
                        console.log(`[service-worker] : message : Broadcasting queue count of ${queueEntries.length}`);
                        postMessageToAllClients({ type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT', value: queueEntries.length });
                        event.ports[0].postMessage(queueEntries.length);
                    });
            }).catch(err =>{
                console.log('[service-worker] : message : Error while replaying requests');
                console.log(err)
                deviceMessagesQueue.getAll()
                    .then(queueEntries => {
                        console.log(`[service-worker] : message : Broadcasting queue count of ${queueEntries.length}`);
                        postMessageToAllClients({ type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT', value: queueEntries.length });
                        event.ports[0].postMessage(queueEntries.length);
                    });
            });
        }

        // On renvoit le nombre de requêtes en attente
        if (event.data && event.data.action === 'GET_PENDING_DEVICE_MESSAGES_COUNT') {
            console.log(`[service-worker] : message : GET_PENDING_DEVICE_MESSAGES_COUNT`)

            deviceMessagesQueue.getAll()
                .then(queueEntries => {
                    event.ports[0].postMessage(queueEntries.length);
                });
        }
    });

    const scheduleReplay = async () => {
        setTimeout(async () => {
            console.log(`[service-worker] : scheduleReplay : Scheduled replay in case background sync is not supported`)
            try {
                const queueEntries = await deviceMessagesQueue.getAll();
                const queueLength = queueEntries.length;
                console.log(`[service-worker] : scheduleReplay : Queue length is ${queueLength}`)
                if (queueLength > 0) {
                    console.log(`[service-worker] : scheduleReplay : Replaying requests`)
                    // Force replay
                    await deviceMessagesQueue.replayRequests();
                }
                const newQueueEntries = await deviceMessagesQueue.getAll();
                console.log(`[service-worker] : scheduleReplay : Broadcasting queue count of ${newQueueEntries.length}`);
                postMessageToAllClients({
                    type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT',
                    value: newQueueEntries.length,
                });
            } catch (error) {
                console.log(`[service-worker] : scheduleReplay : an error occurred`);
                console.log(error);

                try {
                    const currentQueueEntries = await deviceMessagesQueue.getAll();
                    console.log(`[service-worker] : scheduleReplay : Broadcasting queue count of ${currentQueueEntries.length}`);
                    postMessageToAllClients({
                        type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT',
                        value: currentQueueEntries.length,
                    });
                } catch (e) {
                    console.log(`[service-worker] : scheduleReplay : error while getting queue count`);
                    console.log(error)
                }
            } finally {
                // Reprogrammer le prochain appel après 15 secondes
                const currentQueueEntries = await deviceMessagesQueue.getAll();
                if (currentQueueEntries.length > 0) {
                    console.log(`[service-worker] : scheduleReplay : Queue contains ${currentQueueEntries.length} messages left, retry in 60s`);
                    await scheduleReplay();
                } else {
                    console.log(`[service-worker] : scheduleReplay : Queue is empty, not scheduling further replay.`);
                }
            }
        }, 15000);
    }


    // Catch outgoing POST requests to device messages and store them in case of network failures
    self.addEventListener('fetch', event => {
        const url = new URL(event.request.url);
        if (event.request.method === 'POST') {
            if (url.pathname.match(/devices\/[0-9a-f-]+\/messages/)) {
                console.log(`[service-worker] : fetch : new post message request intercepted`);
                event.respondWith(
                    fetch(event.request.clone(), { signal: AbortSignal.timeout(2000) })
                        .catch(async () => deviceMessagesQueue.pushRequest({ request: event.request })
                            .then(response => {
                                scheduleReplay().then(() => {
                                    // Caching the request on Workbox Queue for later replay when the network returns
                                    console.log(`[service-worker] : fetch : replay was scheduled`);
                                    deviceMessagesQueue.getAll()
                                    .then(queueEntries => {
                                        console.log(`[service-worker] : fetch : Broadcasting queue count of ${queueEntries.length}`);
                                        postMessageToAllClients({ type: 'BROADCAST_PENDING_DEVICE_MESSAGES_COUNT', value: queueEntries.length });
                                    });
                                });

                                // Customization of the feedback sent to the app so that it can react
                                return new Response(JSON.stringify({
                                    status: 'pending',
                                    message: 'PENDING_NETWORK'
                                }), {
                                    status: 202,
                                    headers: { 'Content-Type': 'application/json' }
                                });

                            }))
                );
            }
        }
    });
};
